import styled, { css } from 'styled-components'
const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .avatar_form {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .avatar_form label {
    cursor: pointer;
  }
  .avatar_form:hover .avatar_form_edit {
    background: var(--primary-button-border);
  }
  .avatar_form .avatar_form_edit {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 0 0 10px 10px;
    padding: 2px 10px;
    font-size: 0.6rem;
    font-weight: 600;
    background: var(--primary-button-border);
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .avatar_form .profile_avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: url(${({ avatar }) => avatar}) center center / cover no-repeat; */
    width: 50px;
    height: 50px;
    border-radius: 10px;
  }
`
const developerCSS = css``

export const AvatarFormCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
